import styled, { css } from 'styled-components';
import DynamicRspImage from '../../components/base/images/dynamicRspImageBg';
import {A, asAnchor, asHeading5, H2} from '../../components/base/typography';
import { fadeIn } from '../../constants/keyframes/fades';

export const StyledSubRouteLinksWrapper = styled.div`
	margin: 0 auto;
`;

export const SubRouteIconWrapper = styled.div`
	margin-bottom: 2rem;

	svg {
		width: 4.5rem;
		height: 4.5rem;

		g,
		path {
			fill: ${({ theme }) => theme.colors.textColor};
		}
	}
`;

export const SubRoutePictureWrapper = styled(DynamicRspImage)`
	padding-bottom: 60%;
`;

export const SubRouteName = styled(H2)`
	${asHeading5};
	max-width: 80%;
	line-height: 1.4;
	margin-bottom: 1.5rem;
`;

export const SubRouteButton = styled.div`
	${asAnchor};
	display: block;
	margin-top: 1.5rem;
`;

export const SubRouteLink = styled(A)`
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #ffffff;
	box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.1);
	animation: ${fadeIn} 400ms linear;
	transition: box-shadow 250ms;

	&:hover {
		box-shadow: 0px 18px 34px rgba(0, 0, 0, 0.15);
	}
`;

export const ContentWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 4.5rem;
	${({ paddingTop }) =>
		paddingTop &&
		css`
			padding-top: 10rem;
		`}
`;
